<template>
  <v-container fluid style="padding-left: 300px">
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
      <h2 class="title ml-3 mb-3">監査ログ</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <v-form @submit.prevent="searchUserAuths">
          <v-card elevation="0" tile outlined>
            <v-card-text>
              <v-layout align-center>
                <v-text-field
                  v-model="searchQuery.by_user_email_eq"
                  label="変更したユーザーEmail"
                  style="max-width: 250px"
                  clearable
                  class="mr-2"
                />
                <v-text-field
                  v-model="searchQuery.target_user_email_eq"
                  label="対象のユーザーEmail"
                  style="max-width: 250px"
                  clearable
                  class="mr-2"
                />
                <input-date
                  v-model="searchQuery.created_at_gteq"
                  :label="'ログ 開始日'"
                />
                <input-date
                  v-model="searchQuery.created_at_lteq"
                  :label="'ログ 終了日'"
                />
                <v-btn
                  color="primary"
                  dark
                  tile
                  outlined
                  small
                  type="submit"
                  class="ml-3"
                  @click="searchUserAuths"
                  @submit.prevent="searchUserAuths"
                >
                  検索
                </v-btn>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
      <v-col cols="12" lg="10" offset-lg="1">
        <csv-download-container :query="searchQuery" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <v-simple-table>
          <thead>
            <tr>
              <th>変更したユーザーID</th>
              <th>変更したユーザー名前</th>
              <th>変更したユーザーEmail</th>
              <th>対象のユーザーID</th>
              <th>対象のユーザー名前</th>
              <th>対象のユーザーEmail</th>
              <th>変更内容</th>
              <th>変更日</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="log in auditLogs" :key="log.id">
              <td>{{ log.byUserId }}</td>
              <td>{{ log.byUserName }}</td>
              <td>{{ log.byUserEmail }}</td>
              <td>{{ log.targetUserId }}</td>
              <td>{{ log.targetUserName }}</td>
              <td>{{ log.targetUserEmail }}</td>
              <td>{{ log.message }}</td>
              <td>{{ log.createdAt | moment }}</td>
            </tr>
          </tbody>
        </v-simple-table>
        <infinite-loading
          spinner="spiral"
          class="mt-2"
          :identifier="infiniteId"
          @infinite="fetchAuditLog"
        >
          <template v-slot:no-more>
            <v-chip label outlined> 全て表示されました。 </v-chip>
          </template>
          <template v-slot:no-results>
            <v-chip label outlined> 表示できるものがありません。 </v-chip>
          </template>
        </infinite-loading>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import headUtilsMixin from '@/mixins/head_utils'
import axios from 'axios'
import Qs from 'qs'
import { deserialize } from 'deserialize-json-api'
import UserAuthIndexTable from '@/components/commons/UserAuthIndexTable'
import UserAuthSitesForm from '@/components/commons/UserAuthSitesForm'
import InfiniteLoading from 'vue-infinite-loading'
import InputDate from '../OrderReports/InputDate'
import moment from 'moment'
import CsvDownloadContainer from '../../../../src/container/pages/AuditLogs/CsvDownloadContainer'

export default {
  filters: {
    moment: function (val) {
      if (val) {
        return moment(val).format('YYYY/M/D HH:mm')
      }
    }
  },
  components: {
    CsvDownloadContainer,
    UserAuthIndexTable,
    UserAuthSitesForm,
    InfiniteLoading,
    InputDate
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: '監査ログ一覧',
      auditLogs: [],
      page: 1,
      infiniteId: +new Date(),
      searchQuery: {
        by_user_email_eq: '',
        target_user_email_eq: '',
        created_at_gteq: '',
        created_at_lteq: ''
      },
      editDialog: false,
      editingUserAuth: { name: null, sites: null },
      userAuthDataLoading: true
    }
  },
  methods: {
    fetchAuditLog ($state) {
      axios
        .get('/api/master/audit_logs', {
          params: {
            page: this.page,
            q: this.searchQuery
          },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(
          ({ data }) => {
            const fetchAuditLogs = deserialize(data).data

            if (fetchAuditLogs.length > 0) {
              this.page++
              this.auditLogs = this.auditLogs.concat(fetchAuditLogs)
              $state.loaded()
            } else {
              $state.complete()
            }
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.message
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    searchUserAuths () {
      this.page = 1
      this.auditLogs = []
      this.infiniteId = +new Date()
    }
  }
}
</script>

<style scoped></style>
